import { createStore } from 'vuex'
import VuexPersist from 'vuex-persist'
import { get, set, del } from 'idb-keyval'

const idbStorage = {
  getItem: key => get(key),
  setItem: (key, value) => set(key, JSON.parse(JSON.stringify(value))), // ← Double safety
  removeItem: key => del(key)
}

const vuexPersist = new VuexPersist({
  key: 'easyHMO',
  // storage: window.sessionStorage,
  storage: idbStorage,
  asyncStorage: true, // Required for IndexedDB
  reducer: (state) => ({ loginHistory: state.loginHistory, user: state.user, cluster: state.cluster, cache: state.cache, headerModuleShortcuts: state.headerModuleShortcuts })
})

export default createStore({
  state: {
    loginHistory: null,
    user: null,
    cluster: null,
    cache: [],
    dashboardFreshSignin: false,
    headerModuleShortcuts: [],
    realtimeAuthEvent: null,
    realtimeAuthNotice: null,
    realtimeAuthSchemeSwitch: null,
  },
  plugins: [vuexPersist.plugin],
  getters: {
  },
  mutations: {
    loadLoginHistory(state, payload) {
      state.loginHistory = payload;
    },
    loadUser(state, payload) {
      state.user = payload;

      if (!payload) {
        state.headerModuleShortcuts = [];
        state.realtimeAuthEvent = null;
        state.realtimeAuthNotice = null;
        state.realtimeAuthSchemeSwitch = null;
      }
    },
    loadCluster(state, payload) {
      state.cluster = payload;
    },
    loadCache(state, payload) {
      state.cache = payload;
    },
    loadDashboardFreshSignin(state, payload) {
      state.dashboardFreshSignin = payload;
      if (payload) state.headerModuleShortcuts = [];
    },
    visitHeaderModule(state, name) {
      if (!name || name === "home") return;
      const shortcuts = state.headerModuleShortcuts || [];
      if (shortcuts.includes(name)) return;
      state.headerModuleShortcuts = [...shortcuts, name].slice(-3);
    },
    receiveRealtimeAuthEvent(state, payload) {
      state.realtimeAuthEvent = payload;
    },
    showRealtimeAuthNotice(state, payload) {
      state.realtimeAuthNotice = payload;
    },
    queueRealtimeAuthSchemeSwitch(state, payload) {
      state.realtimeAuthSchemeSwitch = payload;
    },
    dismissRealtimeAuthNotice(state, eventId = null) {
      if (!eventId || state.realtimeAuthNotice?.event_id === eventId) {
        state.realtimeAuthNotice = null;
      }
    },
  },
  actions: {
  },
  modules: {
  }
})
